import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import {
  Modal,
  Table,
  Button,
  Col,
  Row,
  Card,
  Form,
  Spinner,
} from "react-bootstrap";
import RequestDetail from "../components/shared/RequestDetail";
import useAuthorization from "../hooks/useAuthorization";
import { useSelector } from "react-redux";
import { selectUser } from "../features/user/userSlice";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import useMediators from "../hooks/useMediators";
import { RequestContext } from "../contexts";
import { fileMimeTypes } from "../assets/data/file-mimes";
import { useForm } from "react-hook-form";
import useFileHelper from "../hooks/useFileHelper";
import FileUpload from "../components/shared/FileUpload";
import AlertModal from "../components/shared/AlertModal";
import { useHistory, useLocation } from "react-router-dom";
import { useAccount, useMsal } from "@azure/msal-react";
import { createAxiosInstance } from "../utils/axios-instance";

dayjs.extend(utc);
const ViewIssue = (props) => {
  const location = useLocation();
  const history = useHistory();
  const [request, setRequest] = useState(null);
  const [isRequestLoading, setIsRequestLoading] = useState(false);
  const [showAttachments, setShowAttachments] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [isDownloadProcessing, setIsDownloadProcessing] = useState(false);
  const [downloadables, setDownloadables] = useState([]);
  const [isAttachmentsLoading, setIsAttachmentsLoading] = useState(false);
  const [downloadError, setDownloadError] = useState("");
  const user = useSelector(selectUser);
  const [conversation, setConversation] = useState([]);
  const [message, setMessage] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [currentRequestToken, setCurrentRequestToken] = useState("");
  const [getMediators] = useMediators();
  const assignToList = getMediators();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({});
  const [isLoading, setIsLoading] = useState(false);
  const [getBase64] = useFileHelper();
  const [showFileUploadSuccess, setShowFileUploadSuccess] = useState(false);
  const [showFileUploadError, setShowFileUploadError] = useState(false);
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0]);

  const handleReload = useCallback(() => {
    setIsRequestLoading(true);
    axios
      .get(
        process.env.REACT_APP_API_ENDPOINT +
          "compliance/requests/" +
          props.match.params.issueId
      )
      .then((resp) => {
        if (resp.status === 204) {
          history.push("/page-not-found");
        } else {
          if (resp.data) {
            setRequest(resp.data);

            setCurrentRequestToken(resp.data.requestToken);
            axios
              .get(
                process.env.REACT_APP_API_ENDPOINT +
                  "compliance/request/inbox/" +
                  resp.data.requestToken
              )
              .then((resp) => {
                setConversation(resp.data);
              });
          }
        }
      })
      .finally(() => setIsRequestLoading(false));
  }, []);
  useEffect(() => {
    if (
      (location.pathname.indexOf("mediator") !== -1 && account) ||
      location.pathname.indexOf("view") !== -1
    ) {
      handleReload();
    }
  }, [account, handleReload, location.pathname]);

  const handleOpenAttachments = (requestId) => {
    setShowAttachments(true);
  };

  const handleAttachmentClose = () => {
    setShowAttachments(false);
  };
  const handleOpenDetails = () => {
    setShowDetails(true);
  };
  const handleCloseDetails = () => {
    setShowDetails(false);
  };
  const sendMessage = () => {
    setIsSending(true);
    const axiosInstance = createAxiosInstance(instance);

    axiosInstance
      .post(process.env.REACT_APP_API_ENDPOINT + "compliance/request/inbox", {
        requestToken: currentRequestToken,
        // subject: user.firstName + ' ' + user.lastName,
        message: message,
        requestInboxType: location.pathname.includes("mediator")
          ? "MEDIATOR"
          : "DOCTOR",
      })
      .then((resp) => {
        setMessage("");
        setIsSending(false);
        // setConversation(resp.data);
        axios
          .get(
            process.env.REACT_APP_API_ENDPOINT +
              "compliance/request/inbox/" +
              currentRequestToken
          )
          .then((resp) => {
            setConversation(resp.data);
            handleCloseDetails();
          });
      });
  };

  const handleDownload = (downloadable) => {
    setIsDownloadProcessing(true);
    axios
      .get(
        `${process.env.REACT_APP_API_ENDPOINT}compliance/request/file/${downloadable.requestFileId}/${currentRequestToken}`
      )
      .then((resp) => {
        const fileType = downloadable.fileName
          .split(".")
          [downloadable.fileName.split(".").length - 1].toLowerCase();
        const mimeType = fileMimeTypes[fileType];
        downloadBase64File(
          resp.data.fileAttachment,
          downloadable.fileName,
          mimeType
        );
        setIsDownloadProcessing(false);
      })
      .catch((err) => {
        setDownloadError(err.message || 'There was an error downloading the file. Please try again.');
        setIsDownloadProcessing(false);
        console.error("Error downloading file:", err);
      });
  };

  const downloadBase64File = (contentBase64, fileName, mimeType) => {
    const linkSource = `data:${mimeType};base64,${contentBase64}`;
    const downloadLink = document.createElement("a");
    document.body.appendChild(downloadLink);

    downloadLink.href = linkSource;
    downloadLink.target = "_self";
    downloadLink.download = fileName;
    downloadLink.click();
  };

  const uploadMessageAttachment = (value) => {
    setIsLoading(true);
    if (value.issueFile && value.issueFile.length > 0) {
      getBase64(value.issueFile[0])
        .then((base64File) => {
          const axiosInstance = createAxiosInstance(instance);
          axiosInstance
            .post(
              process.env.REACT_APP_API_ENDPOINT + "compliance/request/upload",
              {
                fileAttachment: base64File.split(",")[1],
                fileName: value.issueFile[0].name,
                requestToken: currentRequestToken,
                createdBy: account?.idTokenClaims?.name || request.email,
              }
            )
            .then(() => {
              handleAttachmentClose();
              reset();
              setIsLoading(false);
              setShowFileUploadSuccess(true);
            })
            .catch(() => {
              handleAttachmentClose();
              setIsLoading(false);
              setShowFileUploadError(true);
            });
        })
        .catch(() => {
          setShowFileUploadError(true);
          setIsLoading(false);
        });
    }
  };

  const handleCloseSuccess = () => {
    setShowFileUploadSuccess(false);
  };

  const handleCloseError = () => {
    setShowFileUploadError(false);
  };

  useEffect(() => {
    if (showAttachments && request?.requestToken) {
      // For non-authenticated users, use plain axios to avoid MSAL redirects.
      // If the current path is for mediator and an account exists, we can use the auth instance.
      const isMediatorContext =
        location.pathname.indexOf("mediator") !== -1 && account;
      const http = isMediatorContext ? createAxiosInstance(instance) : axios;
      setIsAttachmentsLoading(true);
      http
        .get(
          process.env.REACT_APP_API_ENDPOINT +
            "compliance/request/files/" +
            request.requestToken
        )
        .then((resp) => {
          setDownloadables(resp.data);
        })
        .finally(() => setIsAttachmentsLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showAttachments, request?.requestToken]);
  return (
    <>
      {isRequestLoading && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: 120 }}
        >
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      )}
      {request && !isRequestLoading && (
        <Card>
          {/*{user?.email ? (*/}
          {/*<Card.Header>*/}
          {/*    Request #: {request.requestId}*/}
          {/*</Card.Header>) : (*/}
          <Card.Header>
            Date Created: {dayjs(request.createdDate).format("MM-DD-YYYY")}
          </Card.Header>
          {/*) }*/}
          <Card.Body>
            <RequestContext.Provider
              value={{
                conversation,
                handleSetConversation: (data) => setConversation(data),
              }}
            >
              <RequestDetail
                items={assignToList}
                request={request}
                handleOpenAttachments={handleOpenAttachments}
                handleReload={handleReload}
                handleOpenDetails={handleOpenDetails}
              ></RequestDetail>
            </RequestContext.Provider>
          </Card.Body>
        </Card>
      )}
      <Modal size={"lg"} show={showAttachments} onHide={handleAttachmentClose}>
        <Modal.Header closeButton>
          <Modal.Title>Attachments</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isAttachmentsLoading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: 80 }}
            >
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          ) : downloadables && downloadables.length > 0 ? (
            <>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Filename</th>
                    <th>Size</th>
                    <th>Date Created</th>
                    <th>Download</th>
                  </tr>
                </thead>
                <tbody>
                  {downloadables &&
                    downloadables.map((downloadable, i) => (
                      <tr key={i}>
                        <th>{downloadable.fileName}</th>
                        <th>{downloadable.fileSize}</th>
                        <th>
                          {dayjs(downloadable.createdDate).format("MM-DD-YYYY")}
                        </th>
                        <th>
                          <Button
                            disabled={isDownloadProcessing}
                            size={"xs"}
                            variant={"link"}
                            onClick={() => handleDownload(downloadable)}
                            href="#"
                          >
                            Click to download
                          </Button>
                        </th>
                      </tr>
                    ))}
                </tbody>
              </Table>
              {downloadError && (
                <p style={{ color: "red" }}>
                  {downloadError ? downloadError : "There was an error downloading the file. Please try again."}
                </p>
              )}
            </>
          ) : (
            <h4>There are no available data</h4>
          )}

          {(() => {
            const role = user?.userRole;
            const canUpload =
              !request?.closedDate &&
              (role === "ESSILORADMIN" || role === "MEDIATOR");
            if (!canUpload) return null;
            return (
              <form onSubmit={handleSubmit(uploadMessageAttachment)}>
                <FileUpload register={register} errors={errors} />
                <Button
                  disabled={isLoading}
                  className="float-end btn-fill"
                  type="submit"
                  variant="primary"
                >
                  Upload
                  {isLoading && (
                    <Spinner animation="border" role="status" size="sm">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  )}
                </Button>
              </form>
            );
          })()}
        </Modal.Body>
      </Modal>

      <Modal show={showDetails} onHide={handleCloseDetails}>
        <Modal.Header closeButton>
          <Modal.Title>Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col sm={12}>
              <Form.Group>
                <Form.Label>Message</Form.Label>
                <Form.Control
                  onChange={($event) => {
                    setMessage($event.target.value);
                  }}
                  value={message}
                  aria-label={"Message"}
                  as="textarea"
                  rows={3}
                />
              </Form.Group>
            </Col>
            <Col sm={12} className="mt-25">
              <Row>
                <Col sm={6}>
                  <div className="d-grid">
                    <Button
                      variant="secondary"
                      size={"lg"}
                      disabled={isSending}
                      onClick={handleCloseDetails}
                    >
                      Cancel
                    </Button>
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="d-grid">
                    <Button
                      variant="primary"
                      size={"lg"}
                      disabled={isSending}
                      onClick={sendMessage}
                    >
                      Send
                      {isSending && (
                        <Spinner animation="border" role="status" size="sm">
                          <span className="visually-hidden">Loading...</span>
                        </Spinner>
                      )}
                    </Button>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      <AlertModal
        show={showFileUploadSuccess}
        handleClose={handleCloseSuccess}
        modalTitle={"Upload Attachment Success"}
        modalBody={"You have successfully uploaded the files"}
        handleConfirmButton={handleCloseSuccess}
        confirmButton={"Close"}
      ></AlertModal>

      <AlertModal
        show={showFileUploadError}
        handleClose={handleCloseError}
        modalTitle={"Upload Attachment Error"}
        modalBody={
          "There was a problem uploading files. Please try again later."
        }
        handleConfirmButton={handleCloseError}
        confirmButton={"Close"}
      ></AlertModal>
    </>
  );
};

export default ViewIssue;
